"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarkerDataFromElement = exports.getStaticDataFromContainer = exports.getElementJSONLocation = void 0;
function getElementJSONLocation(el) {
    const locationAttr = el.getAttribute('data-js-map-location') || el.getAttribute('data-js-map-pin-data');
    if (!locationAttr)
        return false;
    let locations = JSON.parse(locationAttr);
    if (!Array.isArray(locations)) {
        locations = [locations];
    }
    return locations;
}
exports.getElementJSONLocation = getElementJSONLocation;
function getStaticDataFromContainer(el) {
}
exports.getStaticDataFromContainer = getStaticDataFromContainer;
function getMarkerDataFromElement(el) {
    const json = getElementJSONLocation(el);
    const defaultValue = [{ lat: undefined, lng: undefined }];
    if (!json) {
        return defaultValue;
    }
    let locationsArray = [];
    json.forEach((location) => {
        var _a, _b, _c, _d;
        if (location !== null && typeof location === 'object' && 'lat' in location && 'lng' in location) {
            const lat = location.lat;
            const lng = location.lng;
            const tooltip = (_a = location.tooltip) !== null && _a !== void 0 ? _a : false;
            const url = (_b = location.url) !== null && _b !== void 0 ? _b : false;
            const icon = (_c = location.icon) !== null && _c !== void 0 ? _c : false;
            const id = (_d = location.id) !== null && _d !== void 0 ? _d : "";
            locationsArray.push({ lat: lat, lng: lng, tooltip: tooltip, url: url, element: el, icon: icon, id: id });
        }
    });
    return locationsArray.length > 0 ? locationsArray : defaultValue;
}
exports.getMarkerDataFromElement = getMarkerDataFromElement;
